import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';

import Form, { SubmitType } from '../../../../components/form';
import Button from '../../../../components/form/elements/button';
import Checkbox from '../../../../components/form/elements/checkbox';
import Date from '../../../../components/form/elements/date';
import Group from '../../../../components/form/elements/group';
import Link from '../../../../components/form/elements/link';
import Text from '../../../../components/form/elements/text';
import Employee from '../../../../interfaces/employee';
import {
  HUMAN_EMPLOYEES_INDEX,
  HUMAN_EMPLOYEES_VIEW,
} from '../../../../router/routes';
import { useService } from '../../../../services/services';
import { route } from '../../../../services/utils';

const schema = yup.object().shape({
  last_name: yup.string().max(255).required(),
  first_name: yup.string().max(255).required(),
  position: yup.string().max(255).required(),
});

export default function CreateEmployee() {
  const { t } = useTranslation();
  const history = useHistory();
  const { farmId } = useParams<{ farmId: string }>();
  const { employeeService } = useService();

  const submit = useCallback<SubmitType<Employee>>(
    (form) => [
      employeeService.store(farmId, form),
      (response) =>
        history.push(route(HUMAN_EMPLOYEES_VIEW, { farmId, id: response.id })),
    ],
    [employeeService, history, farmId]
  );

  const [body] = useState(() => [
    Group([
      Text('last_name'),
      Text('first_name'),
      Text('position'),
      Text('phone', 'contact_phone'),
      Date('hired_at'),
      Date('fired_at'),
      Checkbox('active'),
    ]),
  ]);

  const [footer] = useState(() => [
    Button('create'),
    Link(route(HUMAN_EMPLOYEES_INDEX, { farmId }), 'cancel'),
  ]);

  return (
    <Form
      title={t('pages.human.employees.create_employee')}
      mode="create"
      body={body}
      footer={footer}
      values={{ active: true }}
      submit={submit}
      schema={schema}
    />
  );
}
